// api/importsAPI.ts
import axios from 'axios';
import type { ImportResult } from '@/types/importTypes'; // Actualiza la importación

import api from './index';

/* const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Token a863664b2638bcf6b7e61cfad401d1c6ad221faa`, // 🚨 Considera usar el token dinámico
  }
}); */

export const ImportAPI = {
  executeImport: async (): Promise<ImportResult> => {
    try {
      const response = await api.post('/importar/');
      
      return {
        imported: response.data.stats.imported,
        updated: response.data.stats.updated,
        errors: response.data.stats.errors,
        total: response.data.stats.total
      };
      
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.error || 'Error de importación');
      }
      throw new Error('Error desconocido durante la importación');
    }
  }
};